import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
const StickyAnimation = keyframes({
  from: {
    transform: 'translateY(-100%)',
    opacity: 0
  },
  to: {
    transform: 'translateY(0)',
    opacity: 1
  }
});
const StickyAnimationRevert = keyframes({
  from: {
    transform: 'translateY(0)',
    opacity: 1
  },
  to: {
    transform: 'translateY(-100%)',
    opacity: 0
  }
});
export default {
  stickyNav: (isSticky: boolean, layoutBarsTotalHeight = 0) => ({
    background: 'lightGreyBg2',
    width: '100%',
    position: 'fixed',
    transform: 'translateY(-100%)',
    opacity: 0,
    zIndex: theme.zIndex.contextMenu,
    top: layoutBarsTotalHeight,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflowX: 'hidden',
    boxShadow: `0px -1px 0px 0px ${theme.rawColors.shadowGrey} inset`,
    animation: isSticky ? `${StickyAnimation} .4s linear both` : `${StickyAnimationRevert} .4s linear both`,
    padding: ['0 0 0 20px', '0 0 0 20px', '0 0 0 20px', '0 0 0 20px', '0 0 0 40px'],
    height: ['56px', '56px', '56px', '56px', '72px'],
    transition: `position ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}, top ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`
  }),
  stickyLeftBox: {
    padding: ['8px 0', '8px 0', '8px 0', '8px 0', '8px 0'],
    display: 'flex',
    button: {
      display: 'flex',
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      height: '40px'
    }
  }
};